// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 按需引入element-ui
import element from './utils/element/index'
	// 官方插件vuex
import axios from "axios";
// Vue.prototype.axios = axios;
Vue.use(element)
// 引入封装好的axios请求
// import {
// 	post,request,http
// } from './utils/axios/http'

// 如果存在多个请求封装则以下方式引入
// import { post, get } from './utils/http'
// 挂载到 Vue 实例
// Vue.prototype.$post = post
// Vue.prototype.$request = request
// Vue.prototype.$http = http
Vue.prototype.$axios = axios;
// 如果存在多个请求封装则以下方式挂载
// [或者: 将这些零散的请求归类在一个对象上访问]
// [例如: this.$http.post() | this.$http.get()]

// 
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: 'zh',
	messages: {
	  'zh': require('@/utils/lang/zh.js'),
	  'en': require('@/utils/lang/en.js'),
	  'ru': require('@/utils/lang/ru.js')
	},
	silentTranslationWarn: true,
});

// 阻止启动生产消息
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	i18n,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js